import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }

  var swiper1 = new Swiper(".section1 .mySwiper", {
    speed: 600,
    navigation: {//按钮
      nextEl: ".section1 .swiper-button-next",
      prevEl: ".section1 .swiper-button-prev",
    },
  })
})